module.exports = __webpack_public_path__ + "static/p-logo--makeshop-82037f163891a9a517b12619c49f674b.png";